document.addEventListener('DOMContentLoaded', function() {
  const headerMenus = document.querySelectorAll('header-menu details');
  
  if (window.innerWidth >= 990) {
    headerMenus.forEach(menu => {
      const summary = menu.querySelector('summary');
      
      // Ouvrir au survol
      menu.addEventListener('mouseenter', function() {
        this.setAttribute('open', '');
      });
      
      // Fermer au départ
      menu.addEventListener('mouseleave', function() {
        this.removeAttribute('open');
      });
      
      // Gérer le clic : distinguer clic sur texte vs clic sur flèche
      summary.addEventListener('click', function(e) {
        if (window.innerWidth >= 990) {
          // Si on clique sur la flèche (icône), empêcher la navigation
          if (e.target.classList.contains('icon-caret') || 
              e.target.closest('.icon-caret')) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
          
          // Si on clique sur le texte, suivre le lien
          // Pour ça, il faut trouver l'URL et naviguer
          const summaryId = summary.getAttribute('id');
          if (summaryId) {
            const handle = summaryId.replace('HeaderMenu-', '');
            // Naviguer vers la collection
            window.location.href = '/collections/' + handle;
            e.preventDefault();
          }
        }
      });
    });
  }
});